// Etiquetas · gera QR para volumes, endereços e SKUs · imprime em A4
import QRCode from 'qrcode';
import { repo, generateVolumeCode } from '../client.js';
import { escapeHTML, BRL, DT } from '../shared.js';

const FONT = "'Inter', sans-serif";
const MONO = "'JetBrains Mono', monospace";

export async function viewEtiquetas($c) {
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">ETIQUETAGEM</div>
        <h1>QR e <strong>códigos de barras</strong></h1>
        <p class="lead">Gera etiquetas para volumes (caixas), endereços (prateleiras) e SKUs (fichas). Layout A4 com 8 etiquetas por folha. Imprimir no Cmd+P.</p>
      </div>
      <div class="page-head-actions">
        <button class="btn" id="btn-imprimir" title="Atalho: Cmd+P">Imprimir folha →</button>
      </div>
    </header>

    <div class="grid-3">
      <div class="card">
        <div class="card-head"><h2>Volume novo</h2></div>
        <p class="text-sm text-mute" style="margin-bottom: 14px;">Gera código único <span class="mono-inline">VOL-YYYYMMDD-XXXXXX</span>, cria volume em <em>recebido</em>, registra etiqueta.</p>
        <form id="form-volume" class="form-stack">
          <label>SKU (opcional)<select id="vol-sku"><option value="">— selecionar —</option></select></label>
          <label>Quantidade<input id="vol-qtd" type="number" value="1" step="0.01" min="0"></label>
          <label>Serial (opcional)<input id="vol-serial" placeholder="ex: JN9P1234ABCD"></label>
          <label>Endereço (opcional)<input id="vol-end" placeholder="ex: B-01-1-01"></label>
          <button type="submit" class="btn btn-blue">+ Gerar volume + etiqueta</button>
        </form>
      </div>
      <div class="card">
        <div class="card-head"><h2>Endereço novo</h2></div>
        <p class="text-sm text-mute" style="margin-bottom: 14px;">Cadastra endereço físico no galpão. Etiqueta auto-gerada com QR para colar na prateleira.</p>
        <form id="form-endereco" class="form-stack">
          <label>Código (RUA-MOD-NIVEL-POS)<input id="end-codigo" placeholder="ex: A-03-1-02" required></label>
          <label>Tipo
            <select id="end-tipo">
              <option value="estoque">estoque</option><option value="quarentena">quarentena</option>
              <option value="cross_dock">cross-dock</option><option value="recebimento">recebimento</option>
              <option value="expedicao">expedição</option>
            </select>
          </label>
          <label>Capacidade (qtd)<input id="end-cap" type="number" placeholder="ex: 50" step="0.1"></label>
          <button type="submit" class="btn btn-blue">+ Cadastrar endereço</button>
        </form>
      </div>
      <div class="card">
        <div class="card-head"><h2>Etiqueta de SKU</h2></div>
        <p class="text-sm text-mute" style="margin-bottom: 14px;">Ficha para colar em caixa-mãe ou no SKU master. Inclui descrição + classe + endereço sugerido.</p>
        <form id="form-sku-etq" class="form-stack">
          <label>SKU<select id="sku-pick"><option value="">— selecionar —</option></select></label>
          <button type="submit" class="btn btn-blue">+ Adicionar etiqueta SKU</button>
        </form>
      </div>
    </div>

    <div class="card mt-md">
      <div class="card-head">
        <h2>Pré-visualização <span id="etq-count" class="count">0</span></h2>
        <div class="row gap-sm">
          <button class="btn-mini" id="btn-clear">Limpar</button>
          <button class="btn-mini" id="btn-add-end-bulk" title="Gerar etiquetas para todos os endereços cadastrados">+ Endereços existentes</button>
        </div>
      </div>
      <div id="etq-preview" class="etq-grid"></div>
      <div class="empty" id="etq-empty">Nenhuma etiqueta gerada. Use os formulários acima ou + Endereços existentes.</div>
    </div>
  `;

  // popular SKUs
  try {
    const skus = await repo.estoque({ limit: 500 });
    const opts = skus.map(s => `<option value="${escapeHTML(s.sku_codigo)}">${escapeHTML(s.sku_codigo)} · ${escapeHTML((s.descricao || '').slice(0, 50))}</option>`).join('');
    document.getElementById('vol-sku').innerHTML += opts;
    document.getElementById('sku-pick').innerHTML += opts;
  } catch (_e) { /* sem dados ainda */ }

  const preview = document.getElementById('etq-preview');
  const emptyEl = document.getElementById('etq-empty');
  const countEl = document.getElementById('etq-count');
  const labels = [];

  function refreshCount() {
    countEl.textContent = labels.length;
    emptyEl.style.display = labels.length === 0 ? 'block' : 'none';
  }

  async function renderLabel(label) {
    const el = document.createElement('div');
    el.className = `etiqueta etiqueta-${label.tipo}`;
    const qrSize = 110;
    const qrDataUrl = await QRCode.toDataURL(label.qr_payload, { width: qrSize, margin: 0, color: { dark: '#0A0E27', light: '#FFFFFF' } });
    el.innerHTML = `
      <div class="etq-head">
        <div class="etq-brand">
          <span class="etq-zzyon">ZZYON</span>
          <span class="etq-binario">× BINÁRIO</span>
        </div>
        <div class="etq-tipo">${label.tipoLabel}</div>
      </div>
      <div class="etq-body">
        <img class="etq-qr" src="${qrDataUrl}" alt="QR" />
        <div class="etq-meta">
          <div class="etq-codigo">${escapeHTML(label.codigo)}</div>
          ${label.linha2 ? `<div class="etq-linha">${escapeHTML(label.linha2)}</div>` : ''}
          ${label.linha3 ? `<div class="etq-linha small">${escapeHTML(label.linha3)}</div>` : ''}
        </div>
      </div>
      <div class="etq-foot">${label.foot}</div>
    `;
    preview.appendChild(el);
  }

  async function pushLabel(label) {
    labels.push(label);
    await renderLabel(label);
    refreshCount();
  }

  // criar volume
  document.getElementById('form-volume').addEventListener('submit', async (e) => {
    e.preventDefault();
    try {
      const sku = document.getElementById('vol-sku').value || null;
      const qtd = parseFloat(document.getElementById('vol-qtd').value || '1');
      const serial = document.getElementById('vol-serial').value || null;
      const endereco = document.getElementById('vol-end').value || null;
      const vol = await repo.criarVolume({
        sku_codigo: sku, qtd, serial, endereco,
        status: endereco ? 'endereçado' : 'recebido',
        endereçado_em: endereco ? new Date().toISOString() : null,
      });
      await pushLabel({
        tipo: 'volume', tipoLabel: 'VOLUME', codigo: vol.volume_codigo,
        linha2: sku ? `SKU: ${sku}` : '',
        linha3: `Qtd: ${qtd}  ·  ${endereco || 'sem endereço'}`,
        foot: 'WMS Binário · ' + DT(vol.created_at),
        qr_payload: vol.qr_payload || `BINW:VOL:${vol.volume_codigo}`,
      });
      e.target.reset();
    } catch (err) { alert('Erro: ' + err.message); }
  });

  // criar endereço
  document.getElementById('form-endereco').addEventListener('submit', async (e) => {
    e.preventDefault();
    try {
      const codigo = document.getElementById('end-codigo').value.trim().toUpperCase();
      const parts = codigo.split('-');
      if (parts.length < 4) throw new Error('Formato: RUA-MODULO-NIVEL-POSICAO (ex A-03-1-02)');
      const tipo = document.getElementById('end-tipo').value;
      const capacidade = parseFloat(document.getElementById('end-cap').value || '0') || null;
      const end = await repo.criarEndereco({
        endereco_codigo: codigo,
        rua: parts[0],
        modulo: parseInt(parts[1], 10) || 0,
        nivel: parseInt(parts[2], 10) || 1,
        posicao: parseInt(parts[3], 10) || 1,
        tipo, capacidade_qtd: capacidade,
      });
      await pushLabel({
        tipo: 'endereco', tipoLabel: 'ENDEREÇO', codigo,
        linha2: `Rua ${end.rua} · Mód ${end.modulo} · Nível ${end.nivel}`,
        linha3: end.golden_zone ? '★ GOLDEN ZONE' : end.tipo.toUpperCase(),
        foot: 'Galpão Binário · Joinville/SC',
        qr_payload: `BINW:LOC:${codigo}`,
      });
      e.target.reset();
    } catch (err) { alert('Erro: ' + err.message); }
  });

  // etiqueta SKU
  document.getElementById('form-sku-etq').addEventListener('submit', async (e) => {
    e.preventDefault();
    const sku = document.getElementById('sku-pick').value;
    if (!sku) return;
    try {
      // busca info do sku
      const { db } = await import('../client.js');
      const { data } = await db.from('sku_master').select('descricao,classe_abc,classe_xyz,endereco_atual').eq('sku_codigo', sku).maybeSingle();
      await repo.logEtiqueta({ tipo: 'sku', ref_codigo: sku, qr_payload: `BINW:SKU:${sku}`, barcode_payload: sku });
      await pushLabel({
        tipo: 'sku', tipoLabel: 'SKU', codigo: sku,
        linha2: (data?.descricao || '').slice(0, 50),
        linha3: `Classe ${data?.classe_abc || '·'}${data?.classe_xyz || ''}  ·  ${data?.endereco_atual || 'sem endereço'}`,
        foot: 'Catálogo Binário · ZZYON WMS',
        qr_payload: `BINW:SKU:${sku}`,
      });
    } catch (err) { alert('Erro: ' + err.message); }
  });

  // bulk endereços existentes
  document.getElementById('btn-add-end-bulk').addEventListener('click', async () => {
    try {
      const ends = await repo.listEnderecos();
      if (ends.length === 0) { alert('Nenhum endereço cadastrado ainda.'); return; }
      for (const e of ends) {
        await pushLabel({
          tipo: 'endereco', tipoLabel: 'ENDEREÇO', codigo: e.endereco_codigo,
          linha2: `Rua ${e.rua} · Mód ${e.modulo} · Nível ${e.nivel}`,
          linha3: e.golden_zone ? '★ GOLDEN ZONE' : (e.tipo || '').toUpperCase(),
          foot: 'Galpão Binário · Joinville/SC',
          qr_payload: `BINW:LOC:${e.endereco_codigo}`,
        });
      }
    } catch (err) { alert('Erro: ' + err.message); }
  });

  document.getElementById('btn-clear').addEventListener('click', () => {
    labels.length = 0;
    preview.innerHTML = '';
    refreshCount();
  });

  document.getElementById('btn-imprimir').addEventListener('click', () => {
    document.body.classList.add('print-etq');
    window.print();
    setTimeout(() => document.body.classList.remove('print-etq'), 800);
  });

  refreshCount();
}
